"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _flat = _interopRequireDefault(require("flat"));

var _analytics = require("../../util/analytics");

var _madLibContext = require("./mad-lib-context");

var _madLibPopup = _interopRequireDefault(require("./mad-lib-popup"));

var _madLibUtil = require("./mad-lib-util");

require("./mad-lib.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * MadLib is implemented as a list element. It's tightly coupled with MadLibForm,
 * which it expects as children. We copy them and pass onSubmit and onCancel as props.
 * @param {Object} props - React props
 * @param {Boolean} props.alwaysShow
 *                  This is for development purposes. If always show is true, it will ignore the
 *                  cookie that is set.
 * @param {Array} props.children
 *                  Children are expected to be MadLibForm components. This can be done via
 *                  Contentful by creating a list of type MadLib, and populating the list with
 *                  MadLibForm list items.
 * @param {Number} props.delay
 *                  When props.popup is true, this is the amount in milliseconds that the popup is
 *                  delayed.
 * @param {String} props.endpoint
 *                  Endpoint to submit form values to. This is for development purposes, as we
 *                  expect a global GF_MADLIB_ENDPOINT to exist.
 * @param {Boolean} props.popup
 *                  When true, will render MadLib in a popup
 * @param {String} props.id Used to log info about which version we are using in Contentful.
 * @param {Number} props.showAgainAfterDays Number of days to wait before showing the popup again
 *                 after it is dismissed.
 * @param {Number} props.maxShowCount Maximum number of times to show the mad lib to a user.
 */
var MadLib = /*#__PURE__*/function (_React$Component) {
  _inherits(MadLib, _React$Component);

  var _super = _createSuper(MadLib);

  function MadLib(props) {
    var _this;

    _classCallCheck(this, MadLib);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getEndpoint", function () {
      var endpoint = _this.props.endpoint;

      if (!endpoint) {
        return typeof window !== 'undefined' && window.GF_MADLIB_ENDPOINT;
      }

      return endpoint;
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      var _this$context = _slicedToArray(_this.context, 5),
          segmentEnabled = _this$context[3],
          googleDatastoreDisabled = _this$context[4];

      if (segmentEnabled) {
        _this.sendToSegment(values);
      }

      if (!googleDatastoreDisabled) {
        _this.sendToGoogleDatastore(values);
      } // immediately setState and change screen.
      // Optimistically moving through the form


      _this.setState(function (state) {
        return {
          email: values.email || state.email,
          name: values.name || state.name
        };
      });

      _this.nextScreen();

      (0, _madLibUtil.submitFormAnalytics)();

      _this.setFlag();
    });

    _defineProperty(_assertThisInitialized(_this), "sendToGoogleDatastore", function (values) {
      /* eslint-disable react/destructuring-assignment */

      /* eslint-disable prefer-destructuring */
      var email = values.email || _this.state.email;
      var name = values.name || _this.state.name;
      var info = values.info; // If segment info, submit that too

      var segment = _lodash["default"].isString(values.segment) ? [values.segment] : _lodash["default"].keys(values.segment);
      segment = segment.length ? segment : undefined;
      var segmentOther = values.segmentOther || undefined;

      var endpoint = _this.getEndpoint(); // log URL and ID for more analytics around madlib


      var url = window.location.href;
      var id = _this.props.id; // Capture the number of times the popup was dismissed

      var popupDismissedCount = _madLibPopup["default"].getDismissedCount();

      var _this$context2 = _slicedToArray(_this.context, 3),
          attributions = _this$context2[2];

      (0, _madLibUtil.postEmail)(endpoint, _objectSpread({
        email: email,
        name: name,
        info: info,
        url: url,
        id: id,
        segment: segment,
        segmentOther: segmentOther,
        popupDismissedCount: popupDismissedCount
      }, attributions));
    });

    _defineProperty(_assertThisInitialized(_this), "sendToSegment", function (values) {
      var _this$context3 = _slicedToArray(_this.context, 3),
          attributions = _this$context3[2];

      var id = _this.props.id;
      var screen = _this.state.screen;

      var popupDismissedCount = _madLibPopup["default"].getDismissedCount(); // Avoid sending empty values to Segment


      var segmentFormValues = _lodash["default"].omitBy(values, _lodash["default"].isEmpty);

      var flattenOptions = {
        delimiter: '_'
      }; // Add form responses to user traits

      (0, _analytics.segmentIdentifyAnonymous)(segmentFormValues); // MadLib forms of type `email` will have an email address and name in their
      // form data. We send an event with a special name for this type of form so
      // it can be handled differently by downstream destinations

      if (segmentFormValues.email) {
        (0, _analytics.segmentTrack)('madlib_email_submitted', (0, _flat["default"])(_objectSpread({
          id: id,
          screen: screen,
          popupDismissedCount: popupDismissedCount,
          attributions: attributions
        }, segmentFormValues), flattenOptions));
      } else {
        // If this is not an `email` form, send all of the form values to
        // Segment.
        (0, _analytics.segmentTrack)('madlib_form_submitted', (0, _flat["default"])({
          id: id,
          screen: screen,
          formValues: segmentFormValues
        }, flattenOptions));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "nextScreen", function () {
      _this.setState(function (state) {
        return {
          screen: state.screen + 1
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldHideComponent", function () {
      // debugging purposes
      if (_this.props.alwaysShow) {
        return false;
      } // if we have no endpoint, don't show the madlib


      if (!_this.getEndpoint()) {
        return true;
      } // if there is a flag in local storage, and that flag was not added this flow


      if ((0, _madLibUtil.hasStorageFlag)() && !_this.state.completedThisFlow) {
        return true;
      } // When there are multiple MadLibs on the page, this context allows them
      // to share a hidden flag so completing one hides the others;


      var _this$context4 = _slicedToArray(_this.context, 1),
          madLibHidden = _this$context4[0]; // Also ensure that the flag was not added to this instance of the Mad Lib this flow.


      if (madLibHidden === true && !_this.state.completedThisFlow) {
        return true;
      } // we don't hide by default, return false


      return false;
    });

    _this.state = {
      screen: 0,
      completedThisFlow: false
    };
    return _this;
  }
  /**
   * Endpoint can be passed as a prop for debugging purposes.
   * Otherwise, it should be defined globally.
   * Todo: Pass in via context?
   */


  _createClass(MadLib, [{
    key: "setFlag",
    value:
    /**
     * Set flag and state for successful submission.
     */
    function setFlag() {
      (0, _madLibUtil.setStorageFlag)();
      this.setState({
        completedThisFlow: true
      });

      var _this$context5 = _slicedToArray(this.context, 2),
          setHideMadLib = _this$context5[1];

      setHideMadLib();
    }
    /**
     * Submit form values to Google Datastore
     * @param {object} values
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          delay = _this$props.delay,
          popup = _this$props.popup,
          id = _this$props.id,
          hidden = _this$props.hidden,
          showAgainAfterDays = _this$props.showAgainAfterDays,
          maxShowCount = _this$props.maxShowCount;
      var screen = this.state.screen;

      var childrenArray = _react["default"].Children.toArray(children);

      var child = childrenArray[screen];

      if (!child || this.shouldHideComponent()) {
        // Finished, render nothing
        return null;
      } // calling shownFormAnalytics here because of conditional rendering.
      // this func is implented so it can only be called once


      (0, _madLibUtil.shownFormAnalytics)(); // Pass callbacks to child
      // cloning elements because this allows us to use <sections /> to map contentful data
      // to the MadLibForm. Thus, here we only need to pass callbacks.
      // className is passed to uniquely identify screen for analytics

      var clone = /*#__PURE__*/_react["default"].cloneElement(child, {
        className: "screen-".concat(screen),
        onSubmit: this.onSubmit,
        onCancel: this.nextScreen
      });

      if (popup) {
        return /*#__PURE__*/_react["default"].createElement(_madLibPopup["default"], {
          hidden: hidden,
          id: id,
          delay: delay,
          onClose: this.cancelFlow,
          showAgainAfterDays: showAgainAfterDays,
          maxShowCount: maxShowCount
        }, clone);
      }

      var names = (0, _classnames["default"])('MadLib-wrapper', "madlib-id-".concat(id), {
        hidden: hidden
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: names
      }, clone);
    }
  }]);

  return MadLib;
}(_react["default"].Component);

_defineProperty(MadLib, "contextType", _madLibContext.MadLibContext);

MadLib.propTypes = {
  alwaysShow: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  delay: _propTypes["default"].number,
  endpoint: _propTypes["default"].string,
  popup: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  showAgainAfterDays: _propTypes["default"].number,
  maxShowCount: _propTypes["default"].number
};
MadLib.defaultProps = {
  alwaysShow: false,
  children: null,
  delay: null,
  endpoint: null,
  popup: false,
  id: '',
  hidden: false,
  showAgainAfterDays: 3,
  maxShowCount: 3
};
var _default = MadLib;
exports["default"] = _default;